export type GroupByReturn<T> = { [idx: string]: T[] };
export function groupBy<T extends object>(
  arr: T[],
  groupKey: keyof T | ((s: T) => string)
): GroupByReturn<T> {
  const groups: GroupByReturn<T> = {};
  const isCallable = groupKey instanceof Function;
  arr.forEach((el) => {
    const group = isCallable
      ? groupKey(el)
      : (el[groupKey] as unknown as string);
    groups[group] = groups[group] || [];
    groups[group].push(el);
  }, groups);
  return groups;
}
